import getOne from 'utils/getOne'
import getRows from '../utils/getRows'
import { useEffect } from 'react'
import { apiUrls } from 'consts'

interface useInitFilterSyncLogProps {
  id?: string
  setRows: Function
  setFilterName: Function
  setShowOverlay: Function
}

const useInit = (props: useInitFilterSyncLogProps) => {
  useEffect(() => {
    getOne(apiUrls.filters, props.id!).then((filterData: any) => {
        props.setFilterName(filterData.name)
    })
    getRows({
      id: props.id!,
    }).then((data: any) => {
      props.setRows(data)
      props.setShowOverlay(false)
    })
  }, [])
}

export default useInit
